/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Too_Many_AttemptsInputs */

const en_toast_too_many_attempts = /** @type {(inputs: Toast_Too_Many_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts`)
};

const nl_toast_too_many_attempts = /** @type {(inputs: Toast_Too_Many_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel pogingen`)
};

/**
* | output |
* | --- |
* | "Too many attempts" |
*
* @param {Toast_Too_Many_AttemptsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_too_many_attempts = /** @type {((inputs?: Toast_Too_Many_AttemptsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Too_Many_AttemptsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_too_many_attempts(inputs)
	return en_toast_too_many_attempts(inputs)
});